import { Content } from '../../types';

export const taProhmContent: Content = {
  title: 'מקדש טה פרום Ta Prohm - מקדש העצים השזורים של קמבודיה',
  imageUrl: 'https://tinyurl.com/ta-prohm-wide',
  introduction:
    "מקדש טה פרום Ta Prohm הינו אחד האתרים הקסומים והמיוחדים ביותר במתחם אנגקור שבקמבודיה. הוא נבנה בסוף המאה ה-12 ותחילת המאה ה-13 על ידי המלך ג'יאווארמן השביעי, אשר הקדיש אותו לאמו. טה פרום מפורסם בזכות העצים הענקיים השזורים במבני האבן העתיקים שלו, מה שיוצר אווירה מסתורית וסוריאליסטית שהופכת אותו לאחד האתרים הפופולריים ביותר באנגקור.",
  sections: [
    {
      title: 'ארכיטקטורה ועיצוב',
      type: 'text',
      content:
        "מקדש טה פרום בנוי בסגנון הבודהיזם המהאיאני, בדומה למקדשים נוספים מתקופתו של המלך ג'יאווארמן השביעי. המבנה שלו כולל חצרות מקושרות, מעברים צרים ואולמות גדולים, אשר מוקפים בקירות אבן מגולפים. עם זאת, מה שהופך את טה פרום למיוחד הוא העובדה שהמקדש נותר כמעט כפי שנמצא, עם עצי ענק מסוג ספונג (Ceiba pentandra) וצמחייה טרופית החודרים את קירותיו וחובקים את מבניו, מה שמקנה לו מראה פראי ובלתי נשכח.",
    },
    {
      title: 'מבנה בטה פרום',
      content: '',
      type: 'image',
      imageUrl: 'https://tinyurl.com/ta-prohm-article-1',
    },
    {
      title: 'תבליטים וגילופים',
      type: 'text',
      content:
        'בדומה למקדשים אחרים במתחם אנגקור, גם טה פרום מעוטר בתבליטים מרהיבים המתארים את חיי היומיום באימפריה הקמרית, דמויות אלים ומיתולוגיות בודהיסטיות. אחד האלמנטים הייחודיים במקום הוא גילופי הדוואטה (אלות שמימיות) המעטרות את הקירות ומוסיפות נופך אלגנטי ומיסטי למבנה. התבליטים השמורים יותר מעניקים למבקרים הצצה נדירה אל האמנות והתרבות של התקופה.',
    },
    {
      title: 'השפעות הזמן ושימור',
      type: 'text',
      content:
        'טה פרום נותר כמעט כפי שנמצא על ידי החוקרים האירופאים במאה ה-19, כחלק מהחלטה מכוונת לשמר את האווירה המסתורית של האתר. שורשי העצים העצומים חודרים את קירות המקדש, תומכים בו אך בו זמנית גם מאיימים למוטט אותו. שימור המקדש הוא אתגר הנדסי מורכב, שכן יש לשמור על האיזון העדין בין העצים למבנים העתיקים.',
    },
    {
      title: 'ביקור במקדש',
      type: 'text',
      content:
        'המבקרים בטה פרום חווים תחושה של מסע בזמן כאשר הם משוטטים בין המסדרונות המכוסים שורשים ונכנסים לחללים אפלוליים שבהם צמחייה פראית משתלבת בהרמוניה עם אבני המקום. שעות הבוקר המוקדמות ושעות אחר הצהריים הן הזמן האידיאלי לביקור, כאשר קרני השמש החודרות מבעד לענפי העצים יוצרות משחקי אור וצל מרהיבים.',
    },
    {
      title: 'טה פרום בתרבות הפופולרית',
      type: 'text',
      content:
        'טה פרום הפך לאחד המקדשים המוכרים בעולם לאחר ששימש כלוקיישן לצילומי הסרט "טומב ריידר" בכיכובה של אנג\'לינה ג\'ולי. סצנות הסרט המדגישות את העצים השזורים באבני המקום תרמו לפופולריות העצומה של האתר בקרב תיירים מכל העולם.',
    },
    {
      title: 'סמל תרבותי והיסטורי',
      type: 'text',
      content:
        'מקדש טה פרום הינו לא רק פלא ארכיאולוגי, אלא גם סמל לעוצמתו של הטבע ולשילוב הייחודי שבין יצירות האדם לעולם החי. הוא מייצג את התקופה המפוארת של מלכי אנגקור ואת כוחו של הטבע לעצב מחדש את ההיסטוריה האנושית.',
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, טה פרום הינו אחד המקדשים המרהיבים והמיוחדים ביותר בקמבודיה, בו ניתן להרגיש את הרוח החיה של ההיסטוריה לצד עוצמתו של הטבע. זהו אתר חובה לכל מבקר באנגקור, המשלב יופי, מסתורין והיסטוריה במקום אחד בלתי נשכח.',
    },
  ],
};
